import { Organization, OrganizationMember } from 'src/shared/types/user';

const findUserInOrganization = (
  organization: Organization | null,
  userId: number
): OrganizationMember | null => {
  if (!organization?.members) return null;

  return organization.members.find((m) => m.id === userId) || null;
};

export default findUserInOrganization;
